export const apiUrl =
  "https://iw-backend--new-722437248124.me-central2.run.app";
export const socketUrl =
  "https://iw-backend--new-722437248124.me-central2.run.app";

// export const apiUrl = "https://z4sgbc3v-5002.inc1.devtunnels.ms";
// export const socketUrl = "https://z4sgbc3v-5002.inc1.devtunnels.ms";
// live 1

// export const s3Url = "https://tron-bucket-dev.s3.amazonaws.com";
export const s3Url = "https://storage.googleapis.com/invest-wadi-bucket1"; //gcs
export const imageUrl = (url) => `${s3Url}/${url}`;
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
